/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/assets/_build/webpack_bundles/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 742);
/******/ })
/************************************************************************/
/******/ ({

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.show = show;
exports.hide = hide;
exports.toggle = toggle;
exports.appendChild = appendChild;
exports.appendChildren = appendChildren;
exports.removeChildren = removeChildren;
exports.buildScriptTag = buildScriptTag;
exports.addScriptTag = addScriptTag;
exports.remove = remove;
exports.getElementAttributes = getElementAttributes;
exports.createElement = createElement;
exports.mapElementToProps = mapElementToProps;
exports.css = css;
exports.hasClass = hasClass;
exports.addClass = addClass;
exports.removeClass = removeClass;
exports.toggleClass = toggleClass;
exports.scrollTo = scrollTo;
exports.addToLoadingQueue = addToLoadingQueue;
exports.isDomNode = isDomNode;
var evite = window.evite = window.evite || {};

function show(subject) {
  if (!subject) {
    evite.warn('Expected subject to be non null');
    return;
  }

  if ('show' in subject) {
    subject.show();
  } else {
    subject.classList.remove('hidden');
  }
}

function hide(subject) {
  if (!subject) {
    evite.warn('Expected subject to be non null');
    return;
  }

  if ('hide' in subject) {
    subject.hide();
  } else {
    subject.classList.add('hidden');
  }
}

function toggle(subject) {
  var showElement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!subject) {
    return;
  }

  if (arguments.length === 1) {
    if (subject.toggle) {
      subject.toggle();
      return;
    }

    showElement = subject.offsetParent === null;
  }

  if (showElement) {
    show(subject);
  } else {
    hide(subject);
  }
}

function appendChild(subject, child) {
  if (!subject) {
    return;
  }

  if (subject.append) {
    subject.append(child);
  } else {
    subject.appendChild(child);
  }
}

function appendChildren(subject, children) {
  if (!subject) {
    return;
  }

  children = arguments.length === 2 && Array.isArray(children) ? children : Array.prototype.slice.call(arguments, 1);

  for (var i = 0; i < children.length; ++i) {
    var childOrArray = children[i];
    if (Array.isArray(childOrArray)) {
      appendChildren(subject, childOrArray);
    } else {
      appendChild(subject, childOrArray);
    }
  }
}

function removeChildren(subject) {
  if (!subject) {
    return;
  }
  if ('removeChildren' in subject) {
    subject.removeChildren();
  } else {
    while (subject.lastChild) {
      subject.removeChild(subject.lastChild);
    }
  }
}

function buildScriptTag(_ref) {
  var src = _ref.src,
      type = _ref.type,
      defer = _ref.defer,
      async = _ref.async,
      onLoad = _ref.onLoad,
      onError = _ref.onError,
      className = _ref.className,
      innerText = _ref.innerText,
      innerHTML = _ref.innerHTML;

  defer = Boolean(defer);
  async = Boolean(async);
  onLoad = onLoad || '';
  onError = onError || '';
  className = className || '';
  innerText = innerText || '';

  var id = evite.guid('script-id');

  var scriptTag = document.createElement('script');
  scriptTag.type = type || 'text/javascript';
  scriptTag.async = async;
  scriptTag.defer = defer;
  scriptTag.className = className;

  scriptTag.addEventListener('load', function () {
    evite.resolve(src);
    onLoad();
  });

  scriptTag.addEventListener('error', function () {
    evite.reject(src);
    onError();
  });
  if (src) {
    scriptTag.src = src;
  } else if (innerHTML) {
    scriptTag.innerHTML = innerHTML;
  } else if (innerText) {
    scriptTag.innerText = innerText;
  }

  return scriptTag;
}

// TODO - refactor
function addScriptTag(_ref2) {
  var src = _ref2.src,
      type = _ref2.type,
      defer = _ref2.defer,
      async = _ref2.async,
      onLoad = _ref2.onLoad,
      onError = _ref2.onError,
      className = _ref2.className;


  evite.when('document.ready').then(function () {
    var scriptTag = buildScriptTag({ src: src, type: type, defer: defer, async: async, onLoad: onLoad, onError: onError, className: className });

    appendChild(document.head, scriptTag);
  });
}

function remove(el) {
  if (el && el.parentElement) {
    el.parentElement.removeChild(el);
  }
}

function getElementAttributes(el) {
  var json = {};
  if (el) {
    Array.from(el.attributes).forEach(function (attribute) {
      json[attribute.name] = attribute.value;
    });
  }
  return json;
}

function createElement(elOrTagNameOrComponent, props) {
  var el = void 0;
  if (typeof elOrTagNameOrComponent === 'string') {
    var elStr = elOrTagNameOrComponent;
    elStr = elStr.trim();

    var div = document.createElement('div');
    div.innerHTML = elStr.trim();
    el = div.firstChild;
  } else if ('render' in elOrTagNameOrComponent) {
    el = elOrTagNameOrComponent.render();
  } else if (typeof elOrTagNameOrComponent === 'function') {
    el = elOrTagNameOrComponent(props);
    props = null;
  } else {
    el = elOrTagNameOrComponent;
  }

  if (props) {
    mapElementToProps(el, props);
  }

  for (var _len = arguments.length, children = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    children[_key - 2] = arguments[_key];
  }

  var length = children.length;
  for (var i = 0; i < length; ++i) {
    var child = children[i];
    child = createElement(child);

    appendChild(el, child);
  }

  return el;
}

function mapElementToProps(el, props) {
  if (!el) {
    return null;
  }
  for (var property in props) {
    var value = props[property];
    if ((property === 'styles' || property === 'style') && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
      css(el, value);
    } else if (property === 'dangerouslySetInnerHTML') {
      el.innerHTML = value;
    } else if (property === 'classList') {
      var list = void 0;
      if (typeof value === 'string') {
        list = value.split(/\s+/);
      } else if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && 'forEach' in value) {
        list = value;
      } else {
        list = [value];
      }
      list.forEach(function (className) {
        addClass(el, className);
      });
    } else if (property === 'className') {
      el.setAttribute('class', value);
    } else if (/^on[A-Z]/.test(property) && typeof value === 'function') {
      var eventType = property.replace(/^on/, '').toLowerCase();
      evite.listenTo(el, eventType, value);
    } else {
      el.setAttribute(property, value);
    }
  }

  return el;
}

function css(el, styles) {
  //evite.assert(el, 'Expected element to be non null.');

  if (!el) {
    return;
  }

  if (!styles) {
    el.style.cssText = '';
    return;
  }

  for (var prop in styles) {
    var value = styles[prop];
    if (typeof value === 'number') {
      el.style[prop] = value + 'px';
    } else {
      el.style[prop] = value;
    }
  }
}

function hasClass(el, className) {
  return el && el.classList && el.classList.contains(className) || false;
}

function addClass(el, className) {
  if (el && el.classList) {
    el.classList.add(className);
  }
}

function removeClass(el, className) {
  if (el && el.classList) {
    el.classList.remove(className);
  }
}

function toggleClass(el, className, add) {
  if (arguments.length === 2) {
    add = !hasClass(el, className);
  }

  if (add) {
    addClass(el, className);
  } else {
    removeClass(el, className);
  }
}

/**
 * Scroll to an element on the page
 *
 * modified from https://stackoverflow.com/questions/17722497/scroll-smoothly-to-specific-element-on-page
 * https://jsfiddle.net/s61x7c4e/
 *
 * @param element dom element
 * @param duration
 * @param marginTop additional header room for fixed elements, or if you want to scroll above `element`
 */
function scrollTo(element, duration) {
  var marginTop = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  var startingY = window.pageYOffset;
  var elementY = window.pageYOffset + element.getBoundingClientRect().top - marginTop;
  // If element is close to page's bottom then window will scroll only to some position above the element.
  var tooClose = document.body.scrollHeight - elementY < window.innerHeight;
  var targetY = tooClose ? document.body.scrollHeight - window.innerHeight : elementY;
  var diff = targetY - startingY;
  // Easing function: easeInOutCubic
  // From: https://gist.github.com/gre/1650294
  function easing(t) {
    return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
  }
  var start = void 0;

  if (!diff) return;

  // Bootstrap our animation - it will get called right before next frame shall be rendered.
  window.requestAnimationFrame(function step(timestamp) {
    if (!start) start = timestamp;
    // Elapsed miliseconds since start of scrolling.
    var time = timestamp - start;
    // Get percent of completion in range [0, 1].
    var percent = Math.min(time / duration, 1);
    // Apply the easing.
    // It can cause bad-looking slow frames in browser performance tool, so be careful.
    percent = easing(percent);

    window.scrollTo(0, startingY + diff * percent);

    // Proceed with animation as long as we wanted it to.
    if (time < duration) window.requestAnimationFrame(step);
  });
}

var idleLoadingQueue = [];
var loadingInProgress = void 0;
function addToLoadingQueue(_ref3) {
  var url = _ref3.url,
      priority = _ref3.priority;

  evite.when('window.load').then(function () {
    priority = priority || 0;
    if (url) {
      idleLoadingQueue.splice(priority, 0, url);
      if (!loadingInProgress) {
        evite.requestIdleCallback(loadNextInQueue);
      }
    }
  });

  return evite.when(url);
}

function loadNextInQueue() {
  if (!loadingInProgress && idleLoadingQueue.length) {
    loadingInProgress = true;

    var url = idleLoadingQueue.pop();

    var isImage = /\.(jpeg|jpg|gif|png)\b/i.test(url);
    if (isImage) {
      var image = new Image();
      var completeHandler = handleQueueLoadComplete.bind(null, url, image);
      image.addEventListener('load', completeHandler);
      image.addEventListener('error', completeHandler);
      image.src = url;
      return;
    }

    var isCss = /\.(css)\b/i.test(url);
    if (isCss) {
      var link = evite.dom.createElement('<link rel="stylesheet" media="none"/>', { href: url });
      var _completeHandler = handleQueueLoadComplete.bind(null, url, link);
      link.addEventListener('load', _completeHandler);
      link.addEventListener('error', _completeHandler);
      document.body.appendChild(link);
      return;
    }

    handleQueueLoadComplete();
  }
}

function handleQueueLoadComplete(url, value) {
  loadingInProgress = false;
  if (url) {
    evite.resolve(url, value);
  }

  evite.requestIdleCallback(loadNextInQueue);
}

function isDomNode(o) {
  if (!o) {
    return false;
  }
  return window.HTMLElement && o instanceof HTMLElement || o.nodeType === 1 && typeof o.nodeName === 'string';
}

Object.assign(evite, exports);

evite.dom = evite.dom || {};
Object.assign(evite.dom, exports);

/***/ }),

/***/ 14:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopupModal = undefined;

var _evite_modal = __webpack_require__(2);

var _evite_modal2 = _interopRequireDefault(_evite_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PopupModal = exports.PopupModal = function PopupModal(settings) {
  _classCallCheck(this, PopupModal);

  this.settings = {
    buttons: ['Cancel', 'Yes'],
    html: false,
    title: null,
    body: '',
    width: "480px",
    popup: true
  };

  return new _evite_modal2.default(Object.assign({}, this.settings, settings));
};

exports.default = PopupModal;

/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

var v1 = __webpack_require__(18);
var v4 = __webpack_require__(19);

var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;

module.exports = uuid;


/***/ }),

/***/ 18:
/***/ (function(module, exports, __webpack_require__) {

// Unique ID creation requires a high quality random # generator.  We feature
// detect to determine the best RNG source, normalizing to a function that
// returns 128-bits of randomness, since that's what's usually required
var rng = __webpack_require__(8);
var bytesToUuid = __webpack_require__(9);

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

// random #'s we need to init node and clockseq
var _seedBytes = rng();

// Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
var _nodeId = [
  _seedBytes[0] | 0x01,
  _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]
];

// Per 4.2.2, randomize (14 bit) clockseq
var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;

// Previous uuid creation time
var _lastMSecs = 0, _lastNSecs = 0;

// See https://github.com/broofa/node-uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};

  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  var node = options.node || _nodeId;
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid(b);
}

module.exports = v1;


/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(8);
var bytesToUuid = __webpack_require__(9);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options == 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp, _initialiseProps;

var _base = __webpack_require__(7);

var _base2 = _interopRequireDefault(_base);

var _dom = __webpack_require__(13);

var _utils = __webpack_require__(5);

var _uuid = __webpack_require__(15);

var _uuid2 = _interopRequireDefault(_uuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EviteModal = (_temp = _class = function () {
    function EviteModal(settings) {
        _classCallCheck(this, EviteModal);

        _initialiseProps.call(this);

        this.settings = _extends({}, this.defaults, settings);
        this.id = _uuid2.default.v1();
        this.modal = _base2.default.getInstance();
        this.parser = this.modal.parser;
        this.buildContainer();
    }

    _createClass(EviteModal, [{
        key: 'buildContainer',
        value: function buildContainer() {
            this.target = (0, _utils.htmlFromString)('<div id="eviteModal-' + this.id + '" class="eviteModalContentOuter"><div class="eviteModalContainer"><div class="eviteModalContent"></div></div></div>');
            this.target.querySelector('.eviteModalContainer').style.cssText = '\n            background: white;\n            max-width: ' + this.settings.width + ';\n            border: 1px solid #A8A8A8;\n            border-radius: 6px;\n            overflow: hidden;';
        }
    }, {
        key: 'encodeUrlParams',
        value: function encodeUrlParams(data) {
            var ret = [];
            for (var d in data) {
                ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
            }return ret.join('&');
        }
    }, {
        key: '_query_string',
        value: function _query_string() {
            var params = {
                p: JSON.stringify(this.settings.url_parameters),
                parent_url: document.location.href
            };
            return '?' + this.encodeUrlParams(params);
        }
    }, {
        key: 'buildPopup',
        value: function buildPopup() {
            var _this = this;

            return new Promise(function (resolve, reject) {
                if (!_this.settings.body) {
                    reject('"body" is required');
                }
                if (!_this.settings.title) {
                    reject('"title" is required');
                }
                if (!_this.settings.buttons) {
                    reject('"buttons" is required');
                }
                var buttons = _this.settings.buttons;
                var button_markup = '';
                for (var key in buttons) {
                    var button = buttons[key];
                    if (buttons.length === 1 * key + 1) {
                        button_markup += '<a class="button-primary" data-name="' + button + '" data-index="' + key + '">' + button + '</a>';
                    } else {
                        button_markup += '<a class="button-primary-inverse" data-name="' + button + '" data-index="' + key + '">' + button + '</a>';
                    }
                }
                var modalContent = void 0;
                if (_this.settings.parse) {
                    modalContent = '<p>' + _this.settings.body + '</p>';
                }
                var container = _this.target.querySelector('.eviteModalContent');
                container.innerHTML = '\n                <div class=\'popup-modal\'>\n                    <div class="modal-header">\n                        <h1>' + _this.settings.title + '</h1>\n                    </div>\n                    <div class="modal-body">\n                        <div class="wrapper">' + (modalContent || '') + '</div>\n                    </div>\n                    <div class="modal-footer">' + button_markup + '</div>\n                </div>\n            ';

                if (!_this.settings.parse) {
                    container.querySelector('.wrapper').appendChild(_this.settings.body);
                }

                var self = _this;
                function respondToPopup(e) {
                    self.close();
                    if (self.settings.onResponse) self.settings.onResponse.apply(self, [e, self]);
                }

                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = Object.keys(_this.settings.buttons)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var _key = _step.value;

                        container.querySelectorAll('.modal-footer a')[_key].addEventListener('click', respondToPopup);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                resolve(true);
            });
        }
    }, {
        key: 'buildRemote',
        value: function buildRemote() {
            var _this2 = this;

            return new Promise(function (resolve, reject) {
                _this2.fetchContent().then(function (text) {
                    return _this2.parseContent(text);
                }).then(function (page) {
                    return _this2.injectContent(page);
                }).then(_this2.parseDependencies).then(resolve).catch(function (msg) {
                    return reject(msg);
                });
            });
        }
    }, {
        key: 'show',
        value: function show(htmlResponse) {
            var _this3 = this;

            document.querySelector('body').appendChild(this.target);
            this.modal.initialize(this);
            if (htmlResponse && !this.settings.popup) {
                this.buildFromResponse(htmlResponse);
                this.modal.open('#eviteModal-' + this.id);
                this.open = true;
                return;
            }
            if (this.settings.popup) {
                this.buildPopup().then(function () {
                    _this3.modal.open('#eviteModal-' + _this3.id);
                    _this3.open = true;
                });
            } else {
                this.buildRemote().then(function () {
                    _this3.modal.open('#eviteModal-' + _this3.id);
                    _this3.open = true;
                });
            }
        }
    }]);

    return EviteModal;
}(), _initialiseProps = function _initialiseProps() {
    var _this4 = this;

    this.target = null;
    this.modalHead = null;
    this.modalBody = null;
    this.parser = null;
    this.open = false;
    this.id = null;
    this.defaults = {
        popup: false,
        width: "480px",
        parse: true
    };

    this.fetchContent = function () {
        var url = _this4.settings.url;
        url += _this4.settings.url_parameters ? _this4._query_string() : '';
        return new Promise(function (resolve, reject) {
            window.evite.fetch(url, {
                method: 'get',
                credentials: "same-origin",
                cache: 'no-cache'
            }).then(function (response) {
                resolve(response.text());
            }).catch(function (message) {
                reject(message);
            });
        });
    };

    this.parseContent = function (text) {
        return _this4.parser.parseFromString(text, "text/html");
    };

    this.injectContent = function (page) {
        _this4.modalHead = page.head;
        _this4.modalBody = page.body.innerHTML;
        _this4.target.querySelector('.eviteModalContent').innerHTML = _this4.modalBody;
        return _this4;
    };

    this.showLoader = function () {
        _this4.loader = document.querySelector('.insideLoader');
        _this4.loader.style.display = 'block';
    };

    this.hideLoader = function () {
        _this4.loader = document.querySelector('.insideLoader');
        _this4.loader.style.display = 'none';
    };

    this.parseDependencies = function () {
        var scripts = Array.from(_this4.modalHead.querySelectorAll('script'));
        var links = Array.from(_this4.modalHead.querySelectorAll('link'));
        var styles = links.filter(function (link) {
            return link.type === "text/css";
        });
        styles.forEach(function (style) {
            style.className = 'eviteModalStyle';
            document.head.appendChild(style);
        });
        scripts.forEach(function (script) {
            var scriptTag = void 0;
            var src = script.getAttribute('src');
            if (src) {
                scriptTag = (0, _dom.buildScriptTag)({
                    src: src,
                    type: 'text/javascript',
                    async: true,
                    className: 'eviteModalScript',
                    onLoad: function onLoad() {
                        return false;
                    }
                });
            } else {
                scriptTag = (0, _dom.buildScriptTag)({
                    type: 'text/javascript',
                    innerHTML: script.innerHTML,
                    className: 'eviteModalScript',
                    onLoad: function onLoad() {
                        return false;
                    }
                });
            }
            document.head.appendChild(scriptTag);
        });
        return _this4;
    };

    this.buildFromResponse = function (serverResponse) {
        var page = _this4.parseContent(serverResponse);
        _this4.injectContent(page);
        _this4.parseDependencies();
    };

    this.close = function () {
        return new Promise(function (resolve, reject) {
            if (_this4.open) {
                _this4.modal.close().then(function () {
                    _this4.open = false;
                    var modalDom = document.getElementById('eviteModal-' + _this4.id);
                    var styles = document.querySelectorAll('.eviteModalStyle');
                    var scripts = document.querySelectorAll('.eviteModalScript');
                    Array.from(styles).forEach(function (el) {
                        return el.parentNode.removeChild(el);
                    });
                    Array.from(scripts).forEach(function (el) {
                        return el.parentNode.removeChild(el);
                    });
                    if (modalDom) modalDom.parentNode.removeChild(modalDom);
                    resolve();
                });
            }
        });
    };

    this.respond = function (options, settings) {
        _this4.modal.respond(options, settings);
    };
}, _temp);
exports.default = EviteModal;

/***/ }),

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _popup_modal = __webpack_require__(14);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// A little Backbone view for displaying a copy invitation warning before allowing the copy of the invitation. Setup
// the page  with an anchor tag. The anchor tag should have a proper href with the copy invitation URL. This View will
// intercept that click, stop it, and then use the HREF for forwarding if the user chooses to continue. This way we
// do not need to know the copy URL in the view nor do we have to break functionality if for some reason we have a
// browser experiencing JavaScript issues.
var CopyInvitation = function (_Backbone$View) {
    _inherits(CopyInvitation, _Backbone$View);

    function CopyInvitation() {
        _classCallCheck(this, CopyInvitation);

        return _possibleConstructorReturn(this, (CopyInvitation.__proto__ || Object.getPrototypeOf(CopyInvitation)).apply(this, arguments));
    }

    _createClass(CopyInvitation, [{
        key: 'copy_invitation',
        value: function copy_invitation(e) {
            e.preventDefault();
            e.stopPropagation();

            var response_callback = function response_callback(response, dialog) {
                if (response.target.innerHTML === 'Copy') {
                    window.location = e.target.href;
                } else {
                    dialog.close();
                }
            };
            var body = 'Are you sure you want to make a copy of this invitation? ' + 'Clicking copy will create a duplicate of this invitation and add it to your Upcoming Events.';
            var dialog = new _popup_modal.PopupModal({
                buttons: ['Cancel', 'Copy'],
                body: body,
                title: "Copy Invitation",
                onResponse: function onResponse(response) {
                    return response_callback(response, dialog);
                }
            });
            dialog.show();
        }
    }, {
        key: 'events',
        get: function get() {
            return {
                'click': 'copy_invitation'
            };
        }
    }]);

    return CopyInvitation;
}(Backbone.View);

;

window.CopyInvitation = CopyInvitation;

/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.card_height = card_height;
exports.pluralize = pluralize;
exports.insertAfter = insertAfter;
exports.insertBefore = insertBefore;
exports.htmlFromString = htmlFromString;
exports.isEmpty = isEmpty;
exports.popup_window = popup_window;
exports.configure_selectboxes = configure_selectboxes;
exports.valid_email = valid_email;
exports.guest_valid_email = guest_valid_email;
exports.parse_us_phone_number = parse_us_phone_number;
exports.normalize_phone_number = normalize_phone_number;
exports._get_digits_from = _get_digits_from;
exports.pretty_format_phone_number = pretty_format_phone_number;
exports.getURLParameter = getURLParameter;
exports.parseParams = parseParams;
exports.stringifyParams = stringifyParams;
function card_height(class_name) {
    var height = 400;
    switch (class_name) {
        case 'panel':
            height = 475;
            break;
        case 'postcard':
            height = 555;
            break;
        case 'full':
            height = 555;
            break;
        case 'big_and_tall':
            height = 735;
    }
    return height + 'px';
};

function pluralize(label, count) {
    label = count === 1 ? label : label + 's';
    return count + ' ' + label;
}

function insertAfter(newNode, node) {
    node.parentNode.insertBefore(newNode, node.nextSibling);
}

function insertBefore(newNode, node) {
    node.parentNode.insertBefore(newNode, node);
}

function htmlFromString(string) {
    var div = document.createElement('div');
    div.innerHTML = string;
    return div.firstChild;
}

function isEmpty(obj) {
    return Object.keys(obj).length === 0;
}

function popup_window(loc, width, height, resizable, scrollbars, toolbar, dependent, window_name, location_bar, status_bar, align) {
    var left_position = 1;
    var top_position = 1;

    if (align === "center") {
        left_position = screen.width ? (screen.width - width) / 2 : 0;
        top_position = screen.height ? (screen.height - height) / 2 : 0;
    } else if (align === "topright") {
        left_position = screen.width ? screen.width - width : 0;
        top_position = 1;
    } else if (align === "topcenter") {
        left_position = screen.width ? (screen.width - width) / 2 : 0;
        top_position = 1;
    }

    var align_value = 'top=' + top_position + ',left=' + left_position;
    var win = eval("window.open(loc, '${window_name}','width=${width},height=${height},resizable=${resizable},scrollbars=" + scrollbars + ",toolbar=" + toolbar + ",dependent=" + dependent + ",screenX=1,screenY=1,${align_value},location=${location_bar},status=${status_bar}')");
    win.focus();
};

function configure_selectboxes() {
    function toggle_unselected_style(target) {
        var _selectbox = $(target);
        if (!_selectbox || _selectbox.val() === '' || !_selectbox.val()) {
            $(_selectbox).addClass('unselected');
        } else {
            $(_selectbox).removeClass('unselected');
        }
    };

    var selectboxes = $('.select-holder select');
    selectboxes.each(function (index, selectbox) {
        toggle_unselected_style(selectbox);

        $(selectbox).change(function (e) {
            toggle_unselected_style(e.currentTarget);
        });
    });
};

/**
 * valid_email(email)
 *
 * - says whether the provided email address is valid or not, and if not,
 *   why
 * - returns an Object with three attributes:
 *   {
 *      is_valid: <boolean>,
 *      error_code: <string>
 *      error_message: <string>
 *   }
 *  - possible error codes (strings):
 *    - 'email_empty'
 *    - 'email_invalid'
 *    - 'email_too_long'
 *  - callers can use those error codes to provide their own,
 *    context-specific error messaging
 *
 **/
function valid_email(email) {
    if (!Boolean(email)) {
        return { is_valid: false, error_code: 'email_empty', error_message: 'The email address is empty.' };
    }

    var email_invalid_message = 'The email address is invalid.';
    var ret_email_invalid = { is_valid: false, error_code: 'email_invalid', error_message: email_invalid_message };

    // W3C HTML5 Validation
    if (!/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/i.test(email)) {
        return ret_email_invalid;
    }

    // can't start with a dash
    if (/^\-/i.test(email)) {
        return ret_email_invalid;
    }

    // require a tld
    if (email.split('@')[1].split('.').length < 2) {
        return ret_email_invalid;
    }

    if (email.length > 320) {
        return { is_valid: false, error_code: 'email_too_long', error_message: 'The email address too long. Max length is 320 characters.' };
    }

    return { is_valid: true, error_code: '', error_message: '' };
}

// specialized version of valid_email, above, for guest emails - returns
// a 2-element array of [<is_valid>, <error_message>]
function guest_valid_email(email) {
    var email_invalid_messages = {
        email_empty: 'Please include an email for this guest.',
        email_invalid: 'Please provide a valid email address.',
        email_too_long: 'Email too long. Max length is 320 characters.',
        '': '' // for when there's no error
    };
    var validity = valid_email(email);
    return [validity.is_valid, email_invalid_messages[validity.error_code]];
}

/**
 * parse_us_phone_number(phone_number_text)
 *
 * (also works for canadian phone numbers)
 *
 * - pulls out a 10-digit number sequence (string) from the text entered,
 *   if possible
 * - if an 11-digit sequence is found and the first is a 1 (old school
 *   for "long distance"), the first digit (1) is discarded
 * - returns an Object with three attributes:
 *   {
 *      is_valid: <boolean>,
 *      formatted: <string>
 *      digits: <string>
 *   }
 *
 * Examples:
 * - parse_us_phone_number('  310.123-4567 ') returns:
 *   {
 *      "is_valid": true,
 *      "formatted": "(310) 123-4567",
 *      "digits": "3101234567"
 *   }
 * - parse_us_phone_number('3456 tom ugh') returns:
 *   {
 *      "is_valid": false,
 *      "formatted": "",
 *      "digits": "3456"
 *   }
 *
 **/
function parse_us_phone_number(phone_number_text) {
    var digits = _get_digits_from(phone_number_text);
    var is_standard_length = digits.length === 10;
    var is_1_prefixed_standard_length = digits.length === 11 && digits.charAt(0) === '1';
    if (!(is_standard_length || is_1_prefixed_standard_length)) {
        return {
            is_valid: false,
            formatted: '',
            digits: digits
        };
    }
    if (is_1_prefixed_standard_length) {
        digits = digits.slice(1, 11); // toss the leading 1
    }
    // TODO should this also make sure a 10-digit digit sequence is a valid
    // phone number, or is that overkill?
    return {
        is_valid: true,
        formatted: _format_to_us_phone_number(digits),
        digits: digits
    };
}

function normalize_phone_number(phone_number_string) {
    // Returns the original string if it doesn't validate
    var parsed = parse_us_phone_number(phone_number_string);
    if (parsed.is_valid) return "+1" + parsed.digits;
    return phone_number_string;
}

// return just the digit characters from the given string
function _get_digits_from(string_with_digits) {
    var allDigitChars = string_with_digits.match(/\d+/g) || [];
    return allDigitChars.join('');
}

function pretty_format_phone_number(phone_digits_string) {
    // Returns a pretty formatted phone number, or the original if it is not a normalized phone number
    if (!phone_digits_string) return phone_digits_string;
    var digits = phone_digits_string.trim();
    if (digits[0] === '+') digits = digits.slice(1);
    if (digits[0] === '1' && digits.length === 11) digits = digits.slice(1);
    if (digits.match(/\D/) || digits.length !== 10)
        // Not a proper phone number, so return the original string
        return phone_digits_string;
    return _format_to_us_phone_number(digits);
}

// Ex: "3101234567" ==> "(310) 123-4567"
function _format_to_us_phone_number(digits) {
    return '(' + digits.slice(0, 3) + ') ' + digits.slice(3, 6) + "-" + digits.slice(6, 10);
}

function getURLParameter(name) {
    // mocks
    var search = window.mock_location_search || window.location.search;
    var matches = new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(search) || [null, ''];
    var data = decodeURIComponent(matches[1].replace(/\+/g, '%20'));
    if (data) return data;
    return null;
}

/**
 * stolen from the plugin jquery.parseParams
 *
 * @param query the url query (minus the ?)
 * @returns object of url parameters
 */
function parseParams(query) {
    var re = /([^&=]+)=?([^&]*)/g;
    var decodeRE = /\+/g; // Regex for replacing addition symbol with a space
    var decode = function decode(str) {
        return decodeURIComponent(str.replace(decodeRE, " "));
    };

    var params = {},
        e = void 0;
    while (e = re.exec(query)) {
        var k = decode(e[1]),
            v = decode(e[2]);
        if (k.substring(k.length - 2) === '[]') {
            k = k.substring(0, k.length - 2);
            (params[k] || (params[k] = [])).push(v);
        } else params[k] = v;
    }
    return params;
}

function stringifyParams(params) {
    var paramList = [];
    for (var key in params) {
        if (params.hasOwnProperty(key)) {
            var value = encodeURIComponent(params[key]);
            paramList.push(key + '=' + value);
        }
    }

    paramList.sort();

    return paramList.join('&');
}

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ 7:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var defaults = {
  modal: '.evite-modal-container',
  modalInner: '.modal-inner',
  modalContent: '.modal-content',
  open: '[data-modal-open]',
  close: '[data-modal-close]',
  dataAttribute: 'data-current-modal',
  page: 'body',
  class: 'modal-visible',
  loadClass: 'evite-modal',
  clickOutside: true,
  closeKeys: [27],
  transitions: true,
  transitionEnd: null,
  onBeforeOpen: null,
  onBeforeClose: null,
  onOpen: null,
  onClose: null,
  allowClose: true
};

function throwError(message) {
  // eslint-disable-next-line no-console
  console.error('ModalView: ' + message);
}

function find(arr, callback) {
  return function (key) {
    var filteredArray = arr.filter(callback);
    return filteredArray[0] ? filteredArray[0][key] : undefined;
  };
}

function transitionEndVendorSniff() {
  var el = document.createElement('div');
  var transitions = [{ key: 'transition', value: 'transitionend' }, { key: 'OTransition', value: 'otransitionend' }, { key: 'MozTransition', value: 'transitionend' }, { key: 'WebkitTransition', value: 'webkitTransitionEnd' }];
  return find(transitions, function (_ref) {
    var key = _ref.key;
    return typeof el.style[key] !== 'undefined';
  })('value');
}

function isPopulatedArray(arr) {
  return Object.prototype.toString.call(arr) === '[object Array]' && arr.length;
}

function getNode(selector, parent) {
  var targetNode = parent || document;
  var node = targetNode.querySelector(selector);
  if (!node) {
    throwError(selector + ' not found in document.');
  }
  return node;
}

function addClass(el, className) {
  if (!(el instanceof HTMLElement)) {
    throwError('Not a valid HTML element.');
  }
  el.setAttribute('class', el.className.split(' ').filter(function (cn) {
    return cn !== className;
  }).concat(className).join(' '));
}

function removeClass(el, className) {
  if (!(el instanceof HTMLElement)) {
    throwError('Not a valid HTML element.');
  }
  el.setAttribute('class', el.className.split(' ').filter(function (cn) {
    return cn !== className;
  }).join(' '));
}

function getElementContext(e) {
  if (e && typeof e.hash === 'string') {
    return document.querySelector(e.hash);
  } else if (typeof e === 'string') {
    return document.querySelector(e);
  }
  throwError('No selector supplied to open()');
  return null;
}

function applyModalSettings(settings) {
  return _extends({}, defaults, settings, {
    transitionEnd: transitionEndVendorSniff()
  });
}

function matches(e, selector) {
  var allMatches = (e.target.document || e.target.ownerDocument).querySelectorAll(selector);
  for (var i = 0; i < allMatches.length; i += 1) {
    var node = e.target;
    while (node && node !== document.body) {
      if (node === allMatches[i]) {
        return node;
      }
      node = node.parentNode;
    }
  }
  return null;
}

var ModalBase = function () {
  function ModalBase(options) {
    var _this = this;

    _classCallCheck(this, ModalBase);

    this.currentInstance = null;
    this.parser = null;
    this.openCloseQueue = null;

    this.closeTransitionHandler = function (e) {
      if (_this.resolveTransition) {
        _this.resolveTransition(_this.closeModal(e));
        _this.resolveTransition = null;
      }
    };

    if (options && options.loader) {
      if (!window.EviteLoadingModal) {
        window.EviteLoadingModal = this;
      } else {
        return window.EviteLoadingModal;
      }
    } else {
      if (!window.EviteModal) {
        window.EviteModal = this;
      } else {
        return window.EviteModal;
      }
    }

    this.parser = new DOMParser();
    this.openCloseQueue = Promise.resolve();

    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.closeKeyHandler = this.closeKeyHandler.bind(this);
    this.outsideClickHandler = this.outsideClickHandler.bind(this);
    this.delegateOpen = this.delegateOpen.bind(this);
    this.delegateClose = this.delegateClose.bind(this);
    this.listen = this.listen.bind(this);
    this.destroy = this.destroy.bind(this);
  }

  _createClass(ModalBase, [{
    key: 'initialize',
    value: function initialize(modalInstance) {
      this.current = null;

      this.settings = applyModalSettings(modalInstance.settings);
      this.dom = this.getDomNodes();
      this.currentInstance = modalInstance;

      this.addLoadedCssClass();
      this.listen();
    }
  }, {
    key: 'getDomNodes',
    value: function getDomNodes() {
      var _settings = this.settings,
          modal = _settings.modal,
          page = _settings.page,
          modalInner = _settings.modalInner,
          modalContent = _settings.modalContent;

      return {
        modal: getNode(modal),
        page: getNode(page),
        modalInner: getNode(modalInner, getNode(modal)),
        modalContent: getNode(modalContent, getNode(modal))
      };
    }
  }, {
    key: 'addLoadedCssClass',
    value: function addLoadedCssClass() {
      addClass(this.dom.page, this.settings.loadClass);
    }
  }, {
    key: 'setOpenId',
    value: function setOpenId(id) {
      var page = this.dom.page;

      page.setAttribute(this.settings.dataAttribute, id || 'anonymous');
    }
  }, {
    key: 'removeOpenId',
    value: function removeOpenId() {
      var page = this.dom.page;

      page.removeAttribute(this.settings.dataAttribute);
    }
  }, {
    key: 'open',
    value: function open(allMatches, e) {
      var _this2 = this;

      return this.openCloseQueue.then(function () {
        // Try to blur any active elements before opening modal
        if (document.activeElement) document.activeElement.blur();

        var _dom = _this2.dom,
            page = _dom.page,
            modalContent = _dom.modalContent;
        var _settings2 = _this2.settings,
            onBeforeOpen = _settings2.onBeforeOpen,
            onOpen = _settings2.onOpen;

        if (!(_this2.current instanceof HTMLElement === false)) {
          throwError('ModalView target must exist on page.');
          return;
        }
        if (_this2.current) _this2.releaseNode(_this2.current);
        _this2.current = getElementContext(allMatches);
        if (!_this2.settings.allowClose) {
          getNode(_this2.settings.close).style.display = 'none';
        }
        if (typeof onBeforeOpen === 'function') {
          onBeforeOpen.call(_this2, e);
        }
        _this2.captureNode(_this2.current);
        _this2.setOpenId(_this2.current.id);
        _this2.isOpen = true;
        addClass(page, _this2.settings.class);

        // set focus on last input element or anchor in the modal EVT-10809
        var lastInput = Array.from(modalContent.querySelectorAll('input, button, a')).pop();
        if (lastInput) lastInput.focus();

        if (typeof onOpen === 'function') {
          onOpen.call(_this2, e);
        }
      });
    }
  }, {
    key: 'detectTransition',
    value: function detectTransition() {
      var modal = this.dom.modal;

      var css = window.getComputedStyle(modal, null);
      return Boolean(['transitionDuration', 'oTransitionDuration', 'MozTransitionDuration', 'webkitTransitionDuration'].filter(function (i) {
        return typeof css[i] === 'string' && parseFloat(css[i]) > 0;
      }).length);
    }
  }, {
    key: 'close',
    value: function close(e) {
      var _this3 = this;

      return this.openCloseQueue.then(function () {
        return new Promise(function (resolve) {
          var _settings3 = _this3.settings,
              transitions = _settings3.transitions,
              transitionEnd = _settings3.transitionEnd,
              onBeforeClose = _settings3.onBeforeClose;

          var hasTransition = _this3.detectTransition();
          if (_this3.isOpen) {
            if (typeof onBeforeClose === 'function') {
              onBeforeClose.call(_this3, e);
            }
            if (transitions && transitionEnd && hasTransition) {
              _this3.closeModalWithTransition(e).then(resolve);
            } else {
              _this3.closeModal(e).then(resolve);
            }
            removeClass(_this3.dom.page, _this3.settings.class);
          } else {
            resolve();
          }
        });
      });
    }
  }, {
    key: 'closeModal',
    value: function closeModal(e) {
      var _this4 = this;

      return this.openCloseQueue.then(function () {
        return new Promise(function (resolve) {
          var onClose = _this4.settings.onClose;

          _this4.removeOpenId(_this4.dom.page);
          _this4.releaseNode(_this4.current);
          if (typeof onClose === 'function') {
            onClose.call(_this4, e);
          }
          _this4.current = null;
          _this4.isOpen = false;
          resolve();
        });
      });
    }
  }, {
    key: 'closeModalWithTransition',
    value: function closeModalWithTransition(e) {
      var _this5 = this;

      return this.openCloseQueue.then(function () {
        return new Promise(function (resolve) {
          _this5.resolveTransition = resolve;
        });
      });
    }
  }, {
    key: 'captureNode',
    value: function captureNode(node) {
      var modalContent = this.dom.modalContent;

      while (node.childNodes.length) {
        modalContent.appendChild(node.childNodes[0]);
      }
    }
  }, {
    key: 'releaseNode',
    value: function releaseNode(node) {
      var modalContent = this.dom.modalContent;

      while (modalContent.childNodes.length) {
        node.appendChild(modalContent.childNodes[0]);
      }
    }
  }, {
    key: 'closeKeyHandler',
    value: function closeKeyHandler(e) {
      var closeKeys = this.settings.closeKeys;

      if (isPopulatedArray(closeKeys) && closeKeys.indexOf(e.which) > -1 && this.isOpen === true) {
        e.preventDefault();
        this.close(e);
      }
    }
  }, {
    key: 'outsideClickHandler',
    value: function outsideClickHandler(e) {
      var clickOutside = this.settings.clickOutside;
      var modalInner = this.dom.modalInner;

      if (clickOutside) {
        var node = e.target;
        while (node && node !== document.body) {
          if (node === modalInner) {
            return;
          }
          node = node.parentNode;
        }
        this.close(e);
      }
    }
  }, {
    key: 'delegateOpen',
    value: function delegateOpen(e) {
      var open = this.settings.open;

      var matchedNode = matches(e, open);
      if (matchedNode) {
        e.preventDefault();
        this.open(matchedNode, e);
      }
    }
  }, {
    key: 'delegateClose',
    value: function delegateClose(e) {
      var close = this.settings.close;

      if (matches(e, close)) {
        e.preventDefault();
        this.close(e);
      }
    }
  }, {
    key: 'listen',
    value: function listen() {
      if (this.isListening) {
        this.unlisten();
      }
      var modal = this.dom.modal;
      var transitionEnd = this.settings.transitionEnd;

      if (!this.isListening) {
        modal.addEventListener(transitionEnd, this.closeTransitionHandler);
        modal.addEventListener('click', this.outsideClickHandler, false);
        document.addEventListener('keydown', this.closeKeyHandler, false);
        document.addEventListener('click', this.delegateOpen, false);
        document.addEventListener('click', this.delegateClose, false);
        this.isListening = true;
      } else {
        throwError('Event listeners already applied.');
      }
    }
  }, {
    key: 'unlisten',
    value: function unlisten() {
      var modal = this.dom.modal;
      var transitionEnd = this.settings.transitionEnd;

      modal.removeEventListener('click', this.outsideClickHandler);
      modal.removeEventListener(transitionEnd, this.closeTransitionHandler);
      document.removeEventListener('keydown', this.closeKeyHandler);
      document.removeEventListener('click', this.delegateOpen);
      document.removeEventListener('click', this.delegateClose);
      this.isListening = false;
    }
  }, {
    key: 'respond',
    value: function respond(response, settings) {
      var useSettings = this.settings;
      if (settings) {
        useSettings = Object.assign(useSettings, settings);
      }
      this.close().then(function () {
        window.tags.page_event(useSettings.url, response.name);
        var name = response.name;
        var on_response = useSettings['on' + name];
        if (on_response) {
          on_response(response);
        } else if (useSettings.onResponse) {
          useSettings.onResponse(response);
        }
      });
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      if (this.isListening) {
        this.close();
        this.unlisten();
      } else {
        throwError('Event listeners already removed.');
      }
    }
  }], [{
    key: 'getInstance',
    value: function getInstance() {
      return window.EviteModal || new ModalBase();
    }
  }]);

  return ModalBase;
}();

exports.default = ModalBase;

/***/ }),

/***/ 742:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(304);


/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
var rng;

var crypto = global.crypto || global.msCrypto; // for IE 11
if (crypto && crypto.getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16);
  rng = function whatwgRNG() {
    crypto.getRandomValues(rnds8);
    return rnds8;
  };
}

if (!rng) {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var  rnds = new Array(16);
  rng = function() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}

module.exports = rng;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  return  bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]];
}

module.exports = bytesToUuid;


/***/ })

/******/ });


// WEBPACK FOOTER //
// view_invitation.includes.event-view-js.event-view-past.js